import {
  SERVICE_STAFF_ROLES,
  SERVICE_STAFF_AND_CLIENT_ROLES,
} from "@west-tennessee-consulting/hub-roles";

export const TIME_ENTRY_SCHEDULE_FIELDS = {
start_time: {
    type: "time",
    label: "Start Time",
    placeholder: "Select start time",
    formSpan: 1,
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "timeRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Clock",
    // Internal scheduling granularity — staff only (clients see hours, not raw clock times).
    allowedRoles: [...SERVICE_STAFF_ROLES] as string[],
    mobileDetailSectionId: "work",
  },
end_time: {
    type: "time",
    label: "End Time",
    placeholder: "Select end time",
    formSpan: 1,
    // Table properties
    sortable: true,
    filterable: true,
    searchable: false,
    resizable: true,
    hideable: true,
    editable: true,
    filterType: "timeRange",
    width: 120,
    minWidth: 100,
    maxWidth: 150,
    icon: "Clock",
    // Internal scheduling granularity — staff only (clients see hours, not raw clock times).
    allowedRoles: [...SERVICE_STAFF_ROLES] as string[],
    mobileDetailSectionId: "work",
  }
} as const;
